import { render, staticRenderFns } from "./BordereauPartenairesBbi.vue?vue&type=template&id=3f52d0a3&"
import script from "./BordereauPartenairesBbi.vue?vue&type=script&lang=js&"
export * from "./BordereauPartenairesBbi.vue?vue&type=script&lang=js&"
import style0 from "./BordereauPartenairesBbi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports